import { Button, IconButton } from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';
import React from 'react';
import { ButtonProps } from 'react-awesome-query-builder';

export default ({ type, label, onClick }: ButtonProps) => {
  let icon = <AddIcon />;
  if (['delGroup', 'delRuleGroup', 'delRule'].includes(type)) {
    icon = <DeleteIcon />;
  }

  if (['delGroup', 'delRuleGroup', 'delRule', 'addRuleGroup', 'addRuleGroupExt'].includes(type)) {
    return (
      <IconButton size='small' onClick={onClick} color='default'>
        {icon}
      </IconButton>
    );
  } else {
    return (
      <Button
        size='small'
        onClick={onClick}
        color='default'
        startIcon={icon}
        style={{ color: '#4952FF' }}
      >
        {label}
      </Button>
    );
  }
};
